import { type ApiClient } from "@anna-money/anna-web-lib/api";
import { createSearchParams } from "@anna-money/anna-web-lib/utils";

import { SuburbAutocompleteResponseData } from "services/suburbSearch/suburbSearchTypes";

export class SuburbSearchClient {
  private readonly _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  async getSuburbSuggestions(query: string, state: string): Promise<SuburbAutocompleteResponseData> {
    const response = await this._apiClient.get(
      `api/formations/suburbs/autocomplete?${createSearchParams({ query, state }).toString()}`,
    );

    return response.getData(SuburbAutocompleteResponseData);
  }
}
